import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import LoadingIndicator from './LoadingIndicator';
import { useLocalization } from '../context/LocalizationContext';

interface ConfirmationModalProps {
  show: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'info' | 'success';
  isLoading?: boolean;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  variant = 'danger',
  isLoading = false,
}) => {
  const { t } = useLocalization();

  const confirmLabel = confirmText || t('yes');
  const cancelLabel = cancelText || t('cancel');

  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body aria-busy={isLoading}>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel} disabled={isLoading}>
          {cancelLabel}
        </Button>
          <Button variant={variant} onClick={onConfirm} disabled={isLoading} className="d-inline-flex align-items-center gap-2">
            {isLoading && <LoadingIndicator label={t('loading')} inline compact showLines={false} />}
            {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
